import React from "react";
import './index.css'
import { HiPencilAlt } from "react-icons/hi";



const ButtonSelector = ({title, handleShowModal})=>{
    return(<div onClick={()=>handleShowModal()} className="button-sector-container" >
        <div className="button-sector-subcontainer">
            <HiPencilAlt style={{width:'40px', height:'40px'}}/>
        <p>{title}</p>
        </div>
    </div>)

}

export default ButtonSelector